// extracted by mini-css-extract-plugin
export default {"container":"SupportAccess_container__QDu1J","comment":"SupportAccess_comment__o80II","date":"SupportAccess_date__yyEVl"};